export default __webpack_public_path__ + "static/tftPenguinSmall-ca98f3c15e380297b3d380dd8b4aabe9.png";